import { normaliseStage } from "../utilities/commercialChecklist";

export const BROKER_REVIEW_STAGE = "Broker review";

const KNOWN_STAGES = [
    "Request a quote",
    "Know Your Customer",
    "Ready for quote",
    "Out to market",
    BROKER_REVIEW_STAGE,
    "Quoted",
    "Contract requested",
    "Contract sent",
    "Contract signed",
];

export const canonicalStage = (stage) => KNOWN_STAGES.find((s) => normaliseStage(s) === normaliseStage(stage)) ?? stage;

export const brokerPreviewUrl = (dealId) =>
    `${window.location.origin}/portal/deal-details/sales/${dealId}?preview=quote#quote-section`;

export const whatsAppShareUrl = (url) => `https://wa.me/?text=${encodeURIComponent(url)}`;
